import { render } from "./lida-table-col.vue?vue&type=template&id=52e5cad0&scoped=true"
import script from "./lida-table-col.vue?vue&type=script&lang=js"
export * from "./lida-table-col.vue?vue&type=script&lang=js"

import "./lida-table-col.vue?vue&type=style&index=0&id=52e5cad0&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5cad0"]])

export default __exports__